import React, { createElement, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {AppBar, Notification, Sidebar, Menu, setSidebarVisibility} from 'admin-on-rest';
import CustomMenu from '../Menu/Menu';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {appTitle, WINDOW_WIDTH, BREAKPOINT, MOBILE_VIEW} from "../../../util/util";
import './CustomLayout.css';

const muiTheme = getMuiTheme({ palette:{primary1Color: '#3a518b'} });

class CustomLayout extends Component {
  
  componentWillMount() {
    
    let sidebarVisible = WINDOW_WIDTH > BREAKPOINT;
    
    this.props.setSidebarVisibility(sidebarVisible);
  }
  
  render() {
    
    const { children, dashboard, isLoading, logout } = this.props;
    
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="CustomLayout-wrapper">
          <div className="CustomLayout-main">
            {MOBILE_VIEW || (<AppBar title={appTitle()} />)}
            <div className="body CustomLayout-body">
              <div className="CustomLayout-content">
                {children}
              </div>
              <Sidebar>
                {createElement(CustomMenu || Menu, {
                  logout,
                  hasDashboard: !!dashboard,
                })}
              </Sidebar>
            </div>
            <Notification />
            {isLoading && (
              <CircularProgress
                color="#fff"
                size={30}
                thickness={2}
                className="CustomLayout-loader"
              />
            )}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

CustomLayout.propTypes = {
  authClient: PropTypes.func,
  customRoutes: PropTypes.array,
  dashboard: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  isLoading: PropTypes.bool.isRequired,
  resources: PropTypes.array,
  setSidebarVisibility: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });
export default connect(mapStateToProps, { setSidebarVisibility })(CustomLayout);


// WEBPACK FOOTER //
// ./src/common/components/CustomLayout/CustomLayout.js